import { z } from "zod";

/**
 * Post-event proof cadence tasks (Phase 6). Distinct resource from the
 * T-minus `EventTask` (Phase 3, events.ts) — same open/done/waived shape,
 * but these are only instantiated by the API once an event is marked
 * `delivered` (24h thank-you/review-ask, 48h clip delivery, 7d
 * planner-conditional thank-you, 30d referral check-in). The UI renders
 * whatever the API has instantiated; an empty list before delivery is
 * expected, not an error.
 */

export const ProofTaskStatusSchema = z.enum(["open", "done", "waived"]);
export type ProofTaskStatus = z.infer<typeof ProofTaskStatusSchema>;

export const PROOF_TASK_STATUS_LABELS: Record<ProofTaskStatus, string> = {
  open: "Open",
  done: "Done",
  waived: "Waived",
};

export const ProofTaskSchema = z.object({
  id: z.string(),
  event_id: z.string(),
  template_code: z.string(),
  title: z.string(),
  due_date: z.string().nullable(),
  status: ProofTaskStatusSchema,
  done_at: z.string().nullable(),
  notes: z.string().nullable(),
});
export type ProofTask = z.infer<typeof ProofTaskSchema>;

export const ProofTaskListResponseSchema = z.object({
  items: z.array(ProofTaskSchema),
});
export type ProofTaskListResponse = z.infer<typeof ProofTaskListResponseSchema>;

// ---- Mutation inputs -------------------------------------------------------

export interface PatchProofTaskInput {
  eventId: string;
  taskId: string;
  status?: ProofTaskStatus;
  notes?: string | null;
}
